import { floatingSurface } from '@components/Shared/Dialog/formDialog.styles';
import { alpha, type Theme } from '@mui/material/styles';

/**
 * The menus a row or a page opens (the Folders page's, the Users page's): rows roomy enough to
 * aim at, a hairline between the groups.
 */
export const menuPaperStyles = {
  ...floatingSurface,
  minWidth: 260,
  borderRadius: '12px',
  '& .MuiList-root': {
    p: 0.75,
  },
  '& .MuiDivider-root': {
    my: 0.75,
    mx: -0.75,
    borderColor: alpha('#fff', 0.07),
  },
};

export const menuItemStyles = {
  minHeight: 36,
  px: 1.5,
  gap: 1.5,
  borderRadius: '8px',
  fontSize: 14,
  '& .MuiListItemIcon-root': {
    // A menu item keeps 36 pixels for its icon; the gap already sets the room beside it.
    minWidth: 0,
    color: 'text.secondary',
  },
  // The theme hides keyboard focus on menu items; here it shows as the hover does.
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: alpha('#fff', 0.07),
  },
};

/** The name of a group of choices in a menu. */
export const menuSubheaderStyles = {
  px: 1.5,
  pt: 0.5,
  pb: 0.25,
  lineHeight: '24px',
  fontSize: 12,
  fontWeight: 500,
  color: 'text.secondary',
  backgroundColor: 'transparent',
};

/** Delete: red, alone at the bottom, so it is never taken for its neighbour. */
export const menuDangerItemStyles = (theme: Theme) => ({
  color: theme.palette.error.light,
  '& .MuiListItemIcon-root': {
    color: 'inherit',
  },
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: alpha(theme.palette.error.main, 0.14),
  },
});
